/**
 * RoleSelectCards — 가입 유형(사장님 / 소속 직원) 선택 카드 2장.
 * 일반 가입(/signup/id)과 SNS 가입(/signup/sns)이 같은 UI를 각자 그리고 있어 패딩·radius가
 * 갈렸다. 한 벌로 합쳐 규격을 고정한다.
 *
 * ui-core `Card`(§15.3)를 쓰지 않는 이유 — 선택 상태·클릭 계약이 없어 `selected` 표현을
 * 소비처가 다시 만들어야 한다(선행과제 R-W-01). prop 이 생기면 회수 대상이다.
 */
import { Badge } from '@indipia/ui-core';

export type SignupRole = 'master' | 'staff';

const ROLES = [
  {
    value: 'master' as const,
    emoji: '👑',
    title: '사장님',
    badge: <Badge variant="soft">마스터</Badge>,
    desc: <>사업자 정보로<br />스튜디오를 개설해요</>,
  },
  {
    value: 'staff' as const,
    emoji: '🧑‍💼',
    title: '소속 직원',
    badge: <Badge status="mute">직원</Badge>,
    desc: <>소속 사업장을 검색해<br />가입 신청을 해요</>,
  },
];

interface RoleSelectCardsProps {
  value: SignupRole;
  onChange: (role: SignupRole) => void;
}

export function RoleSelectCards({ value, onChange }: RoleSelectCardsProps) {
  return (
    <div className="grid grid-cols-2 gap-md">
      {ROLES.map((role) => {
        const selected = value === role.value;
        return (
          <button
            key={role.value}
            type="button"
            onClick={() => onChange(role.value)}
            aria-pressed={selected}
            className="cursor-pointer px-05 py-06 text-center transition-colors"
            style={{
              borderRadius: 'var(--radius-xl)',
              border: `var(--border-width-thick) solid ${selected ? 'var(--gt-primary)' : 'var(--shell-border)'}`,
              background: selected ? 'var(--shell-bg)' : 'var(--shell-surface)',
              boxShadow: selected ? '0 0 0 3px var(--gt-subtle)' : 'none',
              fontFamily: 'inherit',
            }}
          >
            <div className="mb-03 text-heading-md">{role.emoji}</div>
            <div className="mb-02 text-body-sm font-bold text-text">{role.title}</div>
            {role.badge}
            <div className="mt-03 text-caption text-text-secondary">{role.desc}</div>
          </button>
        );
      })}
    </div>
  );
}
